export default __webpack_public_path__ + "static/media/CT_Persona2.1c8e7e8f.png";